// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/browser/lite/" + chunkId + "." + {"104":"002df3b6fd8c928dfb02","777":"79f16a66f9550b76b0bd"}[chunkId] + ".js";
};